module.exports = __webpack_public_path__ + "img/loading.9e96b212.gif";